import { useMemo } from 'react'
import useYesObject from 'yesObject/shared/hooks/useYesObject'
import { UseClassifiedChartsProps } from '../Cockpit.types'
import { Classification, classifyCharts } from '../utils/classifyChartElements'

const useClassifiedCharts = ({
  charts,
  classificationUuid
}: UseClassifiedChartsProps) => {
  const { yesObject: classificationObject, isLoading } = useYesObject({
    objectUUID: classificationUuid,
    objectclassUUID: window.classificationObjectclassUuid,
    skipRelations: false
  })

  const classificationContent =
    classificationObject?.classification_content as string

  const parsedContent = useMemo(() => {
    if (!classificationContent) {
      return []
    }

    try {
      return JSON.parse(classificationContent) as Classification[]
    } catch (error) {
      console.error('Error parsing classification content:', error)
      return []
    }
  }, [classificationContent])

  if (!charts)
    return {
      isLoading,
      sectionsUuids: [],
      classifiedCharts: [[]]
    }

  const classifiedCharts = classificationContent
    ? classifyCharts(charts, parsedContent)
    : [charts]

  return {
    isLoading,
    classifiedCharts,
    sectionsUuids: parsedContent.map((content) => content?.uuid_object || '')
  }
}

export default useClassifiedCharts
